// Centralized recording types for session recordings
export const RECORDING_TYPES = [
    'code_change',
    'cursor_move',
    'chat_message',
    'step_transition',
    'ai_request',
    'session_join',
    'session_leave',
    'file_switch',
    'file_rename',
    'file_delete',
];
export const RECORDING_TYPE_VALUES = RECORDING_TYPES;
